import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=f6943472&scoped=true"
import script from "./MessageCard.vue?vue&type=script&lang=js"
export * from "./MessageCard.vue?vue&type=script&lang=js"
import style0 from "./MessageCard.vue?vue&type=style&index=0&id=f6943472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6943472",
  null
  
)

export default component.exports